import React from 'react';
import styled, { keyframes } from 'styled-components';
import { FiX } from 'react-icons/fi';

const slideIn = keyframes`
  from { transform: translateX(100%); opacity: 0; }
  to { transform: translateX(0); opacity: 1; }
`;

const ToastContainerWrapper = styled.div`
  position: fixed;
  top: 1rem;
  right: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  z-index: 2000;
`;

const ToastItem = styled.div`
  display: flex;
  align-items: center;
  background: ${({ type }) =>
    type === 'success' ? '#2ecc71' : type === 'warning' ? '#f1c40f' : '#e74c3c'};
  color: white;
  padding: 0.75rem 1rem;
  border-radius: 0.25rem;
  min-width: 200px;
  animation: ${slideIn} 0.3s ease forwards;
  box-shadow: 0 2px 6px rgba(0,0,0,0.2);
`;

const Message = styled.span`
  flex: 1;
  margin-right: 0.5rem;
`;

const CloseButton = styled.button`
  background: transparent;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 1rem;
`;

const ToastContainer = ({ toasts, removeToast }) => (
  <ToastContainerWrapper>
    {toasts.map(({ id, message, type }) => (
      <ToastItem key={id} type={type}>
        <Message>{message}</Message>
        <CloseButton onClick={() => removeToast(id)}>
          <FiX />
        </CloseButton>
      </ToastItem>
    ))}
  </ToastContainerWrapper>
);

export default ToastContainer;
